<template>
    <div class="info-item" id="project__list__coordinator" @click="showChangeEngagementManager">
        <div class="info-bubbles exclude-outside-click">
            <span
                class="initials badge badge-primary cursor-pointer exclude-outside-click"
                v-b-tooltip.hover.html
                :title="project.engagement_manager.name"
                v-if="project.engagement_manager"
            >
                <span class="exclude-outside-click">{{project.engagement_manager.name | textInitials}}</span>
            </span>
            <plus-button v-show="!addEngagementManagerFlag" class="tagged-contacts plus-button plus-button--small"></plus-button>
        </div>
        <div class="add-multiselect-group" v-show="addEngagementManagerFlag">
            <div class="custom-field user-field custom-multiselect">
                <multiselect
                ref="engagementManager"
                v-click-outside="outside"
                v-model="project.engagement_manager"
                :options="allActiveUsers"
                :option-height="42"
                :show-labels="false"
                :multiple="false"
                :allow-empty="false"
                label="name"
                track-by="id"
                v-show="addEngagementManagerFlag"
                @close="addEngagementManagerFlag=false"
                @input="engagementManagerChanged();"
                ></multiselect>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    props:["project"],
    data() {
        return {
            addEngagementManagerFlag: false,
        };
    },
    computed: {
        ...mapGetters(["allUsers", "userAbilities", "allActiveUsers"]),

        userCanEditProject() {
			const userId = localStorage.getItem("userId");
            const project = this.project;

			if (this.userAbilities.accessAllProjects) {
				return this.userAbilities.editProject;
			}
			
			let isManager = false;
			if (project.engagement_manager instanceof Object) {
				isManager = userId == project.engagement_manager.id;
			} else {
				isManager = userId == project.engagement_manager;
			}

			return (this.userAbilities.editProject && isManager);
		},
    },
    methods: {
        ...mapActions(["changeProjectEngagementManager"]),

        engagementManagerChanged() {
            this.changeProjectEngagementManager({engagement_manager: this.project.engagement_manager, id: this.project.id})
        },
        outside() {
            this.$set(this, "addEngagementManagerFlag", false);
        },
        showChangeEngagementManager() {
            if(!this.userCanEditProject) return;
            this.addEngagementManagerFlag = true;
            this.$nextTick(() => {
                this.$refs.engagementManager.$el.focus();
            });
        }
    },
}

</script>